import { Tag } from 'antd';
import type { CaseStatus } from '../types';

const colors: Record<CaseStatus, string> = { NEW: 'blue', ASSIGNED: 'purple', IN_PROGRESS: 'gold', PENDING: 'orange', COMPLETED: 'green', CLOSED: 'default' };
export const StatusTag = ({ status }: { status: CaseStatus }) => <Tag color={colors[status]}>{status.replace('_', ' ')}</Tag>;
